import { SET_EDGE_RESEARCH_PROPERTY } from '../actions/edge_crm';

export default function edgeResearchProperty(state = {}, action) {
  switch (action.type) {
  case SET_EDGE_RESEARCH_PROPERTY:
    return (
      { ...state, researchProperty: action.property }
    );
  default:
    return state;
  }
}
